<template>
  <v-dialog v-model="show" persistent max-width="800">
    <v-card>
      <v-card-title>Add cask note</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0 px-0 pt-2">
        <v-form ref="form" v-model="valid">
          <v-container class="pt-4 px-4">
          <v-row>
            <v-col cols="8" md="4">
              <date-picker v-model="note.date" label="Date"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field dense v-model="note.comments" label="Note" outlined :rules="[fieldRules.required,fieldRules.maxLength(200)]" autofocus counter="200"/>
            </v-col>
          </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {format} from 'date-fns'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'InventoryCasksNotesAdd',
  mixins: [createHierarchyList],
  props: {
    value: {type:Boolean, required:true},
    cask: {type:Object, required:false},
    hasNotes: {type:Boolean, required:false}
  },
  data () {
    return {
      show: false,
      loading: false,
      valid: true,
      note: {},
      addItem: false,
      categories: [],
      items: [],
      lotRequired: v => !!v || !this.addItem || 'Required'
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    async value() {
      this.show = this.value;
      this.addItem = false;
      this.note = {date:format(new Date(),'yyyy-MM-dd HH:mm:ss'), comments:''}
    }
  },
  async created() {
    this.addItem = false;
    this.note = {date:format(new Date(),'yyyy-MM-dd HH:mm:ss'), comments:''}
  },
  methods: {
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.loading = true;
      const input = {...this.note, caskId:this.cask.id};
      const results = await this.$apiCall(`mutation InventoryCasksNotesAdd($input:CaskNoteInput!) {
                                                caskNoteAdd(input:$input) {
                                                  id,date,comments
                                                }
                                              }`,
                                          {input});
      this.loading = false;
      if (!results.error) {
        this.$emit('noteAdded', results.data.caskNoteAdd);
        this.$emit('input', false);
      }
    }
  }
}
</script>